export type NonAccessibleUser = 'non-accessible-user';

export function isNonAccessibleUser(user: unknown): user is NonAccessibleUser {
  return (user as string) === 'non-accessible-user';
}
